export class SizeError extends Error {
    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, SizeError.prototype);
        this.name = 'SizeError';
    }
}
